module.exports = __webpack_public_path__ + "img/avtor.99cd0dad.png";